module.exports = __webpack_public_path__ + "5c4d51af2163e5856818a8538a6bc0ee.jpg";